import { render, staticRenderFns } from "./ModalInfoPedido.vue?vue&type=template&id=f2b5be6e&scoped=true&"
import script from "./ModalInfoPedido.vue?vue&type=script&lang=js&"
export * from "./ModalInfoPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b5be6e",
  null
  
)

export default component.exports